import PhoneInput from 'react-phone-input-2';
import { useAxios } from '../hooks/useAxios/useAxios';
import { useAuthModalStore } from '../store/auth-modal';
import { ModalContent } from '../components/features/auth-modal/ModalContent';
import { Register } from '../components/features/auth-modal/Register';
import { useRouter } from 'next/router';
import ALink from '../components/common/ALink';
import { useCallback, useEffect, useRef, useState } from 'react';
import { InputCodeField } from '../components/features/inputCodeField';
import { toast } from 'react-toastify';
import { emailMaxLength } from '../utils/validation/validation-rules';
import { eventTrack, initUserTrack } from '../utils/logrocket';
import MetaHeader from '../components/common/MetaHeader';
import ButtonWithLoading from '../components/common/ButtonWithLoading';
import { connect } from 'react-redux';
import { actions as CartAction } from '../store/cart/actions';

function Login(props) {
  const { cartItems, saveCart, getActualCart } = props;
  const {
    changeHandler,
    // openModal,
    closeModal,
    setActions,
    setDdToken,
    setJwtToken,
    // logOut,
    setErrorMessage,
    setUserRegistered,
    setUserData,
    setCurrentMethod,
    ...state
  } = useAuthModalStore();
  const router = useRouter();
  const [loginType, setLoginType] = useState('phone');
  const [user, setUser] = useState();
  const [newUserTryLogin, setNewUserTryLogin] = useState(false);
  const onSubmitNext = (event, next) => {
    event?.preventDefault?.();
    next?.();
  };
  const isBlankValue = value => !value || value.length === 0;
  const isValidPhoneLength = value => {
    const phone = value || state.phone;
    return phone.length === 11;
  };

  //CODE INPUT BLOCK VARS
  const initialValue = { d1: '', d2: '', d3: '', d4: '', d5: '', d6: '' };
  const [code, setCode] = useState(initialValue);
  const startInput = useRef(null);
  const [isLoadingVerify, setIsLoadingVerify] = useState(false);

  const handleSetCode = (id, value) => {
    setCode(prevState => {
      return {
        ...prevState,
        [id]: value
      };
    });
  };

  const validateEmail = value =>
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
      String(value).toLowerCase()
    );

  const isValidEmail = value => {
    if (isBlankValue(value)) {
      return state.nextButtonTouched ? 'Required' : null;
    } else if (!validateEmail(value)) {
      return state.nextButtonTouched ? 'Incorrect email format' : null;
    }
    return null;
  };

  const goToSingUp = () => {
    setActions('phoneModeSignUp');
    setCurrentMethod('phone');
  };

  const compareCartAfterLogin = () => {
    cartItems?.length ? saveCart(cartItems, true) : getActualCart()
  }

  const { execute: nextSendSms, isLoading: nextSendSmsLoading } = useAxios(
    '/public/buyontrust/auth/send_sms',
    {
      method: 'post',
      data: {
        phone: state.phone
      }
    },
    false,
    data => {
      setDdToken(data.token);

      if (!data?.success) {
        changeHandler({
          isUserRegistered: false
        });
      }

      setErrorMessage(data);
      eventTrack('sms sent');

      if (data?.token) {
        setLoginType(state.currentMethod);
        setActions('showVerificationCodePanel');
      }
    }
  );

  const { execute: nextSignIn, isLoading: nextSignInLoading } = useAxios(
    '/public/buyontrust/auth/sign_in',
    {
      method: 'post',
      data: {
        email:
          state.actions.emailModal || state.actions.showSmsReceivingMethodPanel
            ? state.email
            : '',
        phone:
          state.actions.phoneMode ||
          state.actions.phoneModeSignUp ||
          state.actions.showSmsReceivingMethodPanel
            ? state.phone
            : '',
        type: state.currentMethod === 'phone' ? 'sms' : 'email'
      }
    },
    false,
    data => {
      changeHandler({
        ddToken: data?.token
      });

      if (data?.token) {
        setUser(data);
        setDdToken(data.token);
        setLoginType(state.currentMethod);
        setActions('showVerificationCodePanel');
        if (data?.message?.includes('Account not found')) {
          changeHandler({
            isUserRegistered: false,
            formData: { phone: state.phone },
            phone: state.phone
          });
          setNewUserTryLogin(true);
        }
      }
      setErrorMessage(data);

      // const phone =
      //   state.actions.phoneMode ||
      //   state.actions.phoneModeSignUp ||
      //   state.actions.showSmsReceivingMethodPanel
      //     ? state.phone
      //     : '';
      // const email =
      //   state.actions.emailModal || state.actions.showSmsReceivingMethodPanel
      //     ? state.email
      //     : '';
      // initUserTrack(phone, '', '', email); // <-- 1st
    }
  );

  const { execute: verifyAuthorize } = useAxios(
    '/public/buyontrust/auth/authorize',
    {
      method: 'post',
      data: {
        code: state?.verificationCode,
        token: state?.ddToken,
        store_type: 'furniture'
      }
    },
    false,
    data => {
      if (data?.token && state.isUserRegistered) {
        setJwtToken(data.token);
        if (router.query.from) {
          router.push(router.query.from);
        } else {
           // router.back() doesn't work in safari browser
           const userAgent = navigator.userAgent.toLowerCase();
           const isSafari = /safari/.test(userAgent) && !/chrome/.test(userAgent);
           if (isSafari) {
             router.push('/');
           } else {
             router.back();
           }
        }
      }
      setErrorMessage(data);

      const analyticParams =
        JSON.parse(localStorage.getItem('analytic_params')) || {};
      const hsid = analyticParams?.hsid?.toString() || '';

      const firstName = data.full_name?.split(' ')[0] || '';
      const lastName = data.full_name?.split(' ')[1] || '';
      initUserTrack(hsid, data.phone, firstName, lastName, data.email); // <-- 2nd

      localStorage.setItem('isAfterLogin', 'true');
      compareCartAfterLogin();
    }
  );

  const { execute: verifyNewCustomer } = useAxios(
    '/public/buyontrust/auth/verify_new_customer_phone',
    {
      method: 'post',
      data: {
        code: state?.verificationCode,
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (data?.success) {
        getCustomerInfoByToken();
      } else {
        setErrorMessage(data);
      }

      // if (data?.success) {
      //   setActions('showNewAccountPanel');
      // }

      // setErrorMessage(data);
    }
  );

  const { execute: register } = useAxios(
    '/public/buyontrust/auth/register',
    {
      method: 'post',
      data: {
        customer: state.formData,
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (data?.token) {
        setJwtToken(data.token);
        changeHandler({
          isUserRegistered: true
        });
        closeModal();
        router.push('/');  //'/home'
      }

      localStorage.setItem('isAfterLogin', 'true');
      compareCartAfterLogin();
      setErrorMessage(data);
    }
  );

  const { execute: sendCodeToEmail } = useAxios(
    '/public/buyontrust/auth/send_code_to_email',
    {
      method: 'post',
      data: {
        email: state?.formData.email,
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (data?.success) {
        setLoginType('email');
        setActions('showVerificationCodePanel');
        changeHandler({ verifyAuthEmail: true });
      }

      setErrorMessage(data);
      eventTrack('sendCodeToEmail');
    }
  );

  const { execute: checkCustomerEmail } = useAxios(
    '/public/buyontrust/auth/check_customer_email',
    {
      method: 'post',
      data: {
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (data?.success && !data?.email_exists) {
        // console.log(state);
        // sendCodeToEmail?.();
      }

      setErrorMessage(data);
    }
  );

  const { execute: verifyAuthEmail } = useAxios(
    '/public/buyontrust/auth/verify_auth_email',
    {
      method: 'post',
      data: {
        code: state?.verificationCode,
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (data?.success) {
        register?.();
      }

      setErrorMessage(data);
    }
  );

  const onSubmitVerify = event => {
    setIsLoadingVerify(true);
    event?.preventDefault?.();
    if (state?.verifyAuthEmail) {
      verifyAuthEmail?.().finally(() => {
        setCode(initialValue);
        setIsLoadingVerify(false);
      });
    } else if (state?.verificationCode && state.isUserRegistered) {
      verifyAuthorize?.().finally(() => {
        setCode(initialValue);
        setIsLoadingVerify(false);
      });
    } else if (!state.isUserRegistered) {
      verifyNewCustomer?.().finally(() => {
        setCode(initialValue);
        setIsLoadingVerify(false);
      });
    }

    // setCode(initialValue);
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const createAccount = async data => {
    changeHandler({
      formData: { ...data, country: 'US' },
      phone: data?.phone,
      email: data?.email,
      message: ''
    });
    const result = await checkCustomerEmail?.({ email: data?.email });

    if (!result?.email_exists && result?.success) {
      const resp = await sendCodeToEmail?.({
        email: data?.email,
        token: state?.ddToken
      });
      resp?.success && setLoginType('email');
      eventTrack('create account');
    }

    if (result?.email_exists && result?.success) {
      changeHandler({
        message:
          'This email address is already registered. Please use a different email address or try logging in.'
      });
      scrollToTop();
    }
  };

  const {
    execute: getUpdatedCustomer
  } = useAxios(
    '/public/buyontrust/auth/current_customer?store=furniture',
    { method: 'post' },
    false,
    data => setUserData(data)
  );

  const { execute: updateAccount } = useAxios(
    '/public/buyontrust/auth/register',
    {
      method: 'post',
      data: {
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (data?.token) {
        setJwtToken(data.token);
        getUpdatedCustomer().then(() =>
          console.log('Account updated successfully')
        );
        toast('Account updated successfully', {
          autoClose: 5000,
          style: { background: '#07bc0c', color: 'white' }
        });
        router.push('/'); //'/home'
        eventTrack('update account');
      }
      localStorage.setItem('isAfterLogin', 'true');
      compareCartAfterLogin();
      setErrorMessage(data);
    }
  );

  useEffect(() => {
    if (state.isUserLogged && !router.query.from) {
      router.push('/');
    }
  }, [state.isUserLogged]);

  useEffect(() => {
    changeHandler({
      verificationCode: Object.values(code).join('')
    });
    if (code.d1 !== '') {
      setErrorMessage('');
    }
  }, [code]);

  const chooseMethod = useCallback((method) => {
    setCurrentMethod(method)
    setLoginType(method);
  }, [setCurrentMethod, setLoginType]);

  const { execute: getCustomerInfoByToken } = useAxios(
    '/public/buyontrust/auth/get_customer_by_token',
    {
      method: 'post',
      data: {
        // code: state?.verificationCode,
        token: state?.ddToken
      }
    },
    false,
    data => {
      if (!data?.success) {
        setActions('showNewAccountPanel');
      }

      if (data?.success && data?.message?.length > 0) {
        setActions('showUpdateAccountPanel');
        changeHandler({
          formData: {
            address1: data?.customer.street_1,
            address2: data?.customer.street_2,
            city: data?.customer.city,
            company: data?.customer.company,
            country: 'US',
            email: data?.customer.email,
            firstName: data?.customer.first_name,
            lastName: data?.customer.last_name,
            phone: data?.customer.phone,
            state: data?.customer.state,
            zipcode: data?.customer.zip
          }
        });

      }

      if (data?.success && data?.message === '') {
        register?.({
          token: state?.ddToken,
          customer: {
            address1: data?.customer?.street_1,
            address2: data?.customer?.street_2,
            city: data?.customer?.city,
            company: data?.customer?.company,
            country: 'US',
            email: data?.customer?.email,
            firstName: data?.customer?.first_name,
            lastName: data?.customer?.last_name,
            phone: data?.customer?.phone,
            state: data?.customer?.state,
            zipcode: data?.customer?.zip
          }}).then((result) => {
            if (result?.token) {
              setJwtToken(result.token);
              localStorage.setItem('isAfterLogin', 'true');
              compareCartAfterLogin();
              setErrorMessage(result);
            }
            if (result?.token && state.isUserRegistered) {
              if (router.query.from) {
                router.push(router.query.from);
              } else {
                // router.back() doesn't work in safari browser
                const userAgent = navigator.userAgent.toLowerCase();
                const isSafari =
                    /safari/.test(userAgent) && !/chrome/.test(userAgent);
                if (isSafari) {
                  router.push('/'); //'/home'
                } else {
                  router.back();
                }
              }
            }
          });
      }
    }
  );

  const handleKeyDown = (event, callback) => {
    if (state.phone && event.key === 'Enter') {
      if (
        nextSignInLoading ||
        !state.phone ||
        (!state.message?.includes('Verification code has already been sent.') &&
          (state.message ||
            !isValidPhoneLength(state.phone) ||
            isBlankValue(state.phone))) ||
        state.phone[0] !== '1'
      ) {
        return;
      }

      onSubmitNext(event, callback);
    }
  };

  return (
    <>
      <MetaHeader title={'Login'} />
      <main className="main mb-3">
        <div className="container login-container">
          <div className="row">
            <div className="col-lg-10 mx-auto">
              <div className="row d-flex justify-content-center">
                <div className="col-md-7">
                  <div className="heading mb-1">
                    <h2 className="title text-uppercase text-center">
                      {state.actions.phoneModeSignUp && 'Sign Up'}
                      {(state.actions.phoneMode || state.actions.emailModal) &&
                        'Login'}
                      {state.actions.showNewAccountPanel && 'Create Account'}
                      {state.actions.showUpdateAccountPanel && 'Update Account'}
                      {state.actions.showSmsReceivingMethodPanel &&
                        'Resend authentication code'}
                    </h2>
                  </div>
                  {state.actions.phoneMode && (
                    <ModalContent
                      description={
                        <span>
                          Please enter your mobile number to receive a
                          verification code
                          <span className="text-danger">*</span>
                        </span>
                      }
                      message={state.message}
                      title={
                        <span className="line-height-3 font-weight-bold">
                          Don`t have an account?{' '}
                          <ALink
                            className="login-link"
                            href={'/login'}
                            onClick={() => {
                              setActions('phoneModeSignUp');
                              chooseMethod('phone');
                              setUserRegistered(false);
                            }}
                            style={{
                              textDecoration: 'underline'
                            }}>
                            Sign Up Here
                          </ALink>
                        </span>
                      }>
                      <form
                        className="mb-0"
                        onKeyDown={e => handleKeyDown(e, nextSignIn)}
                        onSubmit={e => onSubmitNext(e, nextSignIn)}>
                        <div className="mb-2">
                          <PhoneInput
                            country={'us'}
                            inputClass="form-input form-wide phoneInput phone-input"
                            inputProps={{
                              name: 'phone',
                              required: true,
                              autoFocus: false
                            }}
                            inputStyle={{ paddingLeft: '15px' }}
                            isValid={value => {
                              if (isBlankValue(value)) {
                                return state.nextButtonTouched
                                  ? 'Required'
                                  : true;
                              } else if (!isValidPhoneLength(value)) {
                                return state.nextButtonTouched
                                  ? 'Too short'
                                  : true;
                              } else if (value[0] !== 1) {
                                return state.nextButtonTouched
                                  ? 'Wrong format'
                                  : true;
                              } else {
                                return true;
                              }
                            }}
                            jumpCursorToEnd
                            onChange={phone => {
                              changeHandler({ formData: { phone }, phone });
                              changeHandler({
                                phone
                              });
                              if (state.message) {
                                setErrorMessage('');
                              }
                            }}
                            onlyCountries={['us', 'ua']}
                            placeholder={'PHONE #'}
                            value={state.phone}
                            containerClass="no-flag"
                            // dropdownClass="no-flag"
                            disableDropdown
                          />
                        </div>
                        <div className="text-center">
                          <ButtonWithLoading
                            className="btn btn-dark btn-block btn-md mt-3 btn-login"
                            disabled={
                              nextSignInLoading ||
                              !state.phone ||
                              (!state.message?.includes(
                                'Verification code has already been sent.'
                              ) &&
                                (state.message ||
                                  !isValidPhoneLength(state.phone) ||
                                  isBlankValue(state.phone))) ||
                              state.phone[0] !== '1'
                            }
                            loading={nextSignInLoading}
                            type="submit">
                            NEXT
                          </ButtonWithLoading>
                        </div>
                      </form>
                    </ModalContent>
                  )}

                  {state.actions.phoneModeSignUp && (
                    <ModalContent
                      description={
                        <span>
                          Please enter your mobile number to receive a
                          verification code
                          <span className="text-danger">*</span>
                        </span>
                      }
                      message={state.message}
                      showFooter={false}
                      title={
                        <span className="line-height-3 font-weight-bold">
                          Already have an account?{' '}
                          <ALink
                            className="login-link"
                            href={'/login'}
                            onClick={() => {
                              setActions('phoneMode');
                              chooseMethod('phone');
                              setUserRegistered(true);
                            }}
                            style={{
                              textDecoration: 'underline'
                            }}>
                            Log In Here
                          </ALink>
                        </span>
                      }>
                      <form
                        className="mb-0"
                        onKeyDown={e => handleKeyDown(e, nextSendSms)}
                        onSubmit={e => onSubmitNext(e, nextSendSms)}>
                        <div className="mb-2">
                          <PhoneInput
                            country={'us'}
                            dropdownClass="flag-container"
                            inputClass="form-input form-wide phoneInput phone-input"
                            inputProps={{
                              name: 'phone',
                              required: true,
                              autoFocus: false
                            }}
                            inputStyle={{ paddingLeft: '15px' }}
                            isValid={value => {
                              if (isBlankValue(value)) {
                                return state.nextButtonTouched
                                  ? 'Required'
                                  : true;
                              } else if (!isValidPhoneLength(value)) {
                                return state.nextButtonTouched
                                  ? 'Too short'
                                  : true;
                              } else if (value[0] !== 1) {
                                return state.nextButtonTouched
                                  ? 'Wrong format'
                                  : true;
                              } else {
                                return true;
                              }
                            }}
                            jumpCursorToEnd
                            onChange={phone => {
                              changeHandler({ formData: { phone }, phone });
                              if (state.message) {
                                setErrorMessage('');
                              }
                            }}
                            onlyCountries={['us']}
                            placeholder={'PHONE #'}
                            value={state.phone}
                            containerClass="no-flag"
                            // dropdownClass="flag-container"
                            disableDropdown
                          />
                        </div>
                        <div className="text-center">
                          <ButtonWithLoading
                            className="btn btn-dark btn-block btn-md mt-3 mb-3 btn-login"
                            disabled={
                              nextSendSmsLoading ||
                              !state.phone ||
                              (!state.message?.includes(
                                'Verification code has already been sent.'
                              ) &&
                                (state.message ||
                                  !isValidPhoneLength(state.phone) ||
                                  isBlankValue(state.phone))) ||
                              state.phone[0] !== '1'
                            }
                            loading={nextSendSmsLoading}
                            type="submit">
                            NEXT
                          </ButtonWithLoading>
                          {/* <span className="text-secondary line-height-3 font-weight-bold">
                          Don't have a phone?{' '}
                          <a
                            style={{
                              cursor: 'pointer',
                              color: '#00aee4',
                              fontWeight: '700'
                            }}
                            onClick={event => changeMode(event)}>
                            Use email
                          </a>
                        </span> */}
                        </div>
                      </form>
                    </ModalContent>
                  )}

                  {state.actions.emailModal && (
                    <ModalContent
                      description={
                        <span>
                          Please enter your email address to receive a
                          verification code
                          <span className="text-danger">*</span>
                        </span>
                      }
                      htmlContent={
                        state.message &&
                        state.message.includes('Account not found')
                          ? '<a class="text-info pointer bold">Sign Up</a>'
                          : null
                      }
                      message={state.message}
                      onClickEvent={goToSingUp}
                      title={
                        <span className="line-height-3 font-weight-bold">
                          Don`t have an account?{' '}
                          <ALink
                            className="login-link"
                            href={'/login'}
                            onClick={() => {
                              setActions('phoneModeSignUp');
                              chooseMethod('phone')
                            }}
                            style={{
                              textDecoration: 'underline'
                            }}>
                            Sign Up Here
                          </ALink>
                        </span>
                      }>
                      <form
                        className="mb-0"
                        onSubmit={e => onSubmitNext(e, nextSignIn)}>
                        <input
                          className="form-input form-wide"
                          id={'login-panel-email'}
                          maxLength={emailMaxLength}
                          onChange={({ target }) => {
                            changeHandler({
                              email: target.value
                            });
                            if (state.message) {
                              setErrorMessage('');
                            }
                          }}
                          onError={isValidEmail(state.email)}
                          placeholder={'EMAIL'}
                          required
                          type="email"
                          value={state.email}
                        />
                        <div className="text-center">
                          <ButtonWithLoading
                            className="btn btn-dark btn-block btn-md mt-3 btn-login"
                            disabled={
                              nextSignInLoading ||
                              !state.email ||
                              (state.message &&
                                !state.message.includes(
                                  'Verification code has already been sent.'
                                )) ||
                              isValidEmail(state.email)
                            }
                            loading={nextSignInLoading}
                            type="submit">
                            NEXT
                          </ButtonWithLoading>
                        </div>
                      </form>
                    </ModalContent>
                  )}

                  {state.actions.showVerificationCodePanel && (
                    <ModalContent
                      description={
                        <div className="d-flex flex-column align-items-center">
                          <span>
                            Please enter the verification code we just sent to
                          </span>
                          {loginType === 'email' ? (
                            <span
                              style={{
                                color: 'black',
                                fontWeight: '700',
                                fontSize: '1.5rem'
                              }}>
                              {state?.email || user?.email}
                            </span>
                          ) : (
                            <span
                              style={{
                                color: 'black',
                                fontWeight: '700',
                                fontSize: '1.5rem'
                              }}>
                              +{state.phone || `1 ${user?.phone}`}
                            </span>
                          )}
                        </div>
                      }
                      message={state.message}
                      title="We just texted you...">
                      <InputCodeField
                        currencyValue={code}
                        onSubmit={onSubmitVerify}
                        setCode={handleSetCode}
                        startInput={startInput}
                      />
                      <div className="text-center">
                        <ButtonWithLoading
                          className="btn btn-dark btn-block btn-md btn-login mt-3"
                          disabled={!code.d1 && !code.d2 && !code.d3 && !code.d4 && !code.d5 && !code.d6}
                          loading={isLoadingVerify}
                          onClick={onSubmitVerify}>
                          NEXT
                        </ButtonWithLoading>
                      </div>
                    </ModalContent>
                  )}

                  {state.actions.showSmsReceivingMethodPanel && (
                    <ModalContent
                      message={state.message}
                      title={
                        <span className="line-height-3 font-weight-bold ">
                          Please select your preferred method of receiving the
                          authentication code
                        </span>
                      }
                    >
                      <label className="d-flex align-center" htmlFor="phone">
                        <div
                          className={`radio-button ${loginType === 'phone' &&
                            'radio-button-checked'}`}
                        />
                        <input
                          checked={loginType === 'phone'}
                          className="hidden"
                          id="phone"
                          onChange={() => chooseMethod('phone')}
                          type="radio"
                          value="phone"
                        />
                        <div className="d-flex flex-row align-items-center">
                          <span className="label-text">
                            Get the code by SMS:{'\u00a0'}
                          </span>
                          <span className="label-text-bold">
                            +{state.phone || `1 ${user?.phone}`}
                          </span>
                        </div>
                      </label>
                      <label className="d-flex align-center" htmlFor="email">
                        <div
                          className={`radio-button ${loginType === 'email' &&
                            'radio-button-checked'}`}
                        />
                        <input
                          checked={loginType === 'email'}
                          className="hidden"
                          id="email"
                          onChange={() => chooseMethod('email')}
                          type="radio"
                          value="email"
                        />
                        <span className="label-text">
                          Get the code by Email:{' '}
                          <span className="label-text-bold">
                            {state.email || user?.email}
                          </span>
                        </span>
                      </label>
                      <div className="text-center">
                        <button
                          className="btn btn-dark btn-block btn-md button-resend font1"
                          onClick={() => nextSignIn()}
                        >
                          NEXT
                        </button>
                        <button
                          className="cancel-button"
                          onClick={() => {
                            setActions('phoneMode');
                            chooseMethod('phone');
                          }}
                        >
                          Cancel
                        </button>
                      </div>
                    </ModalContent>
                  )}
                </div>
              </div>

              {state.actions.showNewAccountPanel && (
                <ModalContent showFooter={false} title="">
                  <Register
                    newUserTryLogin={newUserTryLogin}
                    onSubmitEmit={createAccount}
                    phoneDisable
                  />
                </ModalContent>
              )}

              {state.actions.showUpdateAccountPanel && (
                <ModalContent showFooter={false} title="">
                  <Register
                    onSubmitEmit={data => updateAccount({ customer: data })}
                    phoneDisable
                    textButton={'Update Account'}
                  />
                </ModalContent>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
}

const mapStateToProps = state => {
  return {
    ...(state.cart ? state.cart : {})
  };
};

export default connect(mapStateToProps, CartAction)(Login)